import { Box, Grid, Typography } from "@material-ui/core";
import { Ref, useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { BrowserFile, CreateFileAndFolder } from "../../../shared/components";
import { Header } from "../../../shared/components/header";
import { buildBreadcrumbNavigationConfig } from "../../../shared/helpers/buildBreadcrumbNavigationConfig";
import { useBrowserFile, useInIframe } from "../../../shared/hooks";
import { RootState } from "../../../store";
import {
  deleteFile,
  deleteFolder,
  downloadFile,
  getVaultFiles,
  saveFile,
  saveFolder,
} from "../../services";
import { useStyles } from "./vault.styles";

const HOMEDIRECTORY = "Home";
const INITIALSTATEDEEP = {
  name: HOMEDIRECTORY,
  id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
};

export const Vault = () => {
  const classes = useStyles();
  const [deep, setDeep] = useState([INITIALSTATEDEEP]);
  const idParticipant = useSelector(
    (state: RootState) => state.profile.participantProfileId
  );
  const isInIframe = useInIframe();

  const {
    isFetching,
    debouncedHandleFilterChange,
    handleCreateFolder,
    handleCreateFile,
    handleDeleteFolder,
    handleDeleteFile,
    infiniteRef,
    sourceData,
    request,
    setRequest,
    debouncedHandleSortChange,
    order,
    orderBy,
  } = useBrowserFile(
    getVaultFiles,
    saveFolder,
    saveFile,
    deleteFolder,
    deleteFile,
    50,
    idParticipant
  );

  const downloadSelectedFile = (fileId) => {
    window.location.href = downloadFile({
      paramaterId: idParticipant,
      fileId,
    });
  };

  const handleRequestSort = useCallback(
    (property) => {
      const isAsc = orderBy === property && order === "asc";
      debouncedHandleSortChange(property, isAsc ? "desc" : "asc");
    },
    [orderBy, order, debouncedHandleSortChange]
  );

  const createFile = (file, isPrivate) => {
    const parentId = deep.length === 1 ? null : deep[deep.length - 1].id;
    handleCreateFile(file, parentId, isPrivate);
  };

  const createFolder = (folderName, isPrivate) => {
    const parentId = deep.length === 1 ? null : deep[deep.length - 1].id;
    handleCreateFolder({ name: folderName, parentId, isPrivate });
  };

  const newNavigation = [buildBreadcrumbNavigationConfig("My Files", "/vault")];

  return (
    <Header navigation={newNavigation}>
      <Box className={classes.headerBox}>
        {!isInIframe ? (
          <Typography
            component="h1"
            variant="h5"
            align="left"
            className={classes.title}
          >
            My Files
          </Typography>
        ) : (
          <Box flexGrow={1}></Box>
        )}
        <CreateFileAndFolder
          isFetching={isFetching}
          request={request}
          handleCreateFolder={createFolder}
          handleCreateFile={createFile}
        />
      </Box>
      <Grid item xs={12} ref={infiniteRef as Ref<HTMLDivElement>}>
        <BrowserFile
          isFetching={isFetching}
          setRequest={setRequest}
          request={request}
          files={sourceData}
          debouncedHandleFilterChange={debouncedHandleFilterChange}
          handleCreateFolder={handleCreateFolder}
          handleDeleteFolder={handleDeleteFolder}
          handleCreateFile={handleCreateFile}
          handleDeleteFile={handleDeleteFile}
          handleDownloadFile={downloadSelectedFile}
          onSortChange={handleRequestSort}
          order={order}
          orderBy={orderBy}
          deep={deep}
          setDeep={setDeep}
        />
        {isFetching && (
          <Typography component="h4" variant="body1">
            Loading...
          </Typography>
        )}
      </Grid>
    </Header>
  );
};
